var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"menu-header-image"}},[(_vm.image)?_c('v-img',{attrs:{"contain":!!_vm.customizationMenuHeaderCoverContain,"max-height":_vm.customizationMenuHeaderCoverHeight ?? `150px`,"min-height":_vm.customizationMenuHeaderCoverHeight ?? `150px`,"src":_vm.image}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }